import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, connect } from "react-redux";
import { systemInfoActions } from './Adapters/systemInfo/systemInfo.actions.js';

function App(props) {
    const dispatch = useDispatch();
    const { systemInfo } = useSelector((state) => ({ systemInfo: state.systemInfo }));

    useEffect(() => {
        dispatch(systemInfoActions.getSystemInfo());
    }, [dispatch]);

    return (
        <div id="wrapper" className="container">
            <header className="row g-0">
                <div className="col-12 col-lg-6">
                    <div id="logo" >
                        <img src={`/CustomThemes/${window.Theme}/logo/newlogo.png`}
                            id="navigation-logo" alt="Landing Page" width="100" height="100" />
                        <h1 className="brandTitle">{systemInfo.Brand}</h1>
                    </div>
                </div>
                <aside className="col-12 col-lg-6">
                    <ul className="social-icons">
                        {systemInfo.Cellphone !== null ?
                            <li>
                                <a target="_blank" title="شماره تماس" href={"tel:" + systemInfo.Cellphone}>
                                    <i className="fa fa-phone-volume fa-1x"></i><span>Phone</span>
                                </a>

                            </li>
                            : ''
                        }
                        {systemInfo.WhatsApp !== null ?
                            <li>
                                <a target="_blank" title="واتساپ" href={systemInfo.WhatsApp}>
                                    <i className="fab fa-whatsapp fa-1x"></i><span>WhatsApp</span>
                                </a>
                            </li>
                            : ''
                        }
                        {systemInfo.TelegramChannel !== null ? <li>
                            <a target="_blank" title="تلگرام" href={systemInfo.TelegramChannel}>
                                <i className="fab fa-telegram-plane fa-1x"></i><span>Telegram</span>
                            </a>
                        </li>
                            : ''
                        }
                        {systemInfo.Instagram !== null ? <li>
                            <a target="_blank" title="اینستاگرام" href={systemInfo.Instagram}>
                                <i className="fab fa-instagram fa-1x"></i><span>Instagram</span>
                            </a>
                        </li>
                            : ''
                        }  </ul>
                </aside>
            </header>
            <div id="banner" className="row g-0" tabIndex="-1"
                style={{ backgroundPosition: 'center -8px' }} >

                <div id="banner-content" className="row clearfix">
                    <div className="col-12 col-lg-5">
                        <div className="section-heading">
                            <h2 className="system-description">
                                {systemInfo.SystemDescription}
                            </h2>
                            <p className="contact-info mt-3 whitespace-pre">{systemInfo.ContactInfo}</p>
                        </div>

                        <div className="row g-0 downloadapp-container">
                            <div className="col-6 pe-1">
                                <a className="login-download-btn" download href={window.AppLink} target="_blank">
                                    <i className="svg-mini-icon" style={{ maskImage: "url('/Images/android.svg')", WebkitMaskImage: "url('/Images/android.svg')" }} ></i>
                                    اپلیکیشن اندروید
                                </a>
                            </div>
                            <div className="col-6 ps-1">
                                <a className="login-download-btn" href={window.WebAppLink}>
                                    <i className="svg-mini-icon" style={{ maskImage: "url('/Images/windowAlt.svg')", WebkitMaskImage: "url('/Images/windowAlt.svg')" }} ></i>
                                    نسخه وب اپلیکیشن
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-7">
                        <img src={`/CustomThemes/${window.Theme}/logo/mockup.png`} width="800" height="400" />
                    </div>
                </div>
            </div>
            <footer id="landing-footer" className="row g-0">
                    <p id="copyright" className="col-2">
                        <span>طراحی و پیاده سازی توسط</span>&nbsp;
                        <a href={window.CallBackLink} target="_blank"><span>گروه مهندسی زریار</span> </a>
                    </p>
            </footer>
        </div>
    );
}


export default App;


